export default "__VITE_ASSET__7A94UJNp__"